// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__EOQfx","itemTitle":"ClientEmergencyInfo_itemTitle__3QIww","itemText":"ClientEmergencyInfo_itemText__7t6rE"};